/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { Link } from 'react-router-dom';
// BASE components
import BASESvgIcon from '../../../../@BASE/core/BASESvgIcon';
// Material UI components
import { lighten } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardMedia from "@mui/material/CardMedia";
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
// custom components
import TemplateListItemInfo from './TemplateListItemInfo';

function TemplateListItem(props) {
  const { template } = props;
  return (
    <Card className="flex flex-col shadow relative">
      <CardMedia
        component="img"
        height="240"
        title={template.title}
        image={`https://base-media-repo.web.app/templates/${template.label}/mockups/Desktop.jpg`}
      />
      <CardContent className="flex flex-col flex-auto p-24">
        <TemplateListItemInfo template={template} />
      </CardContent>
      <CardActions
        className="items-center justify-end py-16 px-24"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? lighten(theme.palette.background.default, 0.4)
              : lighten(theme.palette.background.default, 0.03),
        }}
      >
        <Button
          to={`/templates/${template.id}`}
          component={Link}
          className="px-16 min-w-128"
          variant="outlined"
          endIcon={
            <BASESvgIcon className="" size={20}>
              heroicons-solid:arrow-sm-right
            </BASESvgIcon>
          }
        >
          View
        </Button>
      </CardActions>
    </Card>
  );
}

export default TemplateListItem;
